var $7c64b60f22f6542e$exports = {};
$7c64b60f22f6542e$exports = {
    "loading": `\u{12E}keliama...`,
    "loadingMore": `\u{12E}keliama daugiau...`
};


export {$7c64b60f22f6542e$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
